import { getMinutes as dateFnsGetMinutes } from 'date-fns';

const getMinutes = date => (dateFnsGetMinutes(new Date(date)));

export default getMinutes;
